import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CONTENT } from "@/content";
import Gateway from "@/components/Gateway";
import Engineering from "@/components/Engineering";

function App() {
  const [lang, setLang] = useState("tr");
  const t = CONTENT[lang];

  return (
    <div className="App bg-[#E9EDF3] text-[#0B0D10] min-h-screen font-body antialiased">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Gateway lang={lang} setLang={setLang} />} />
          <Route path="/muhendislik" element={<Engineering t={t} lang={lang} setLang={setLang} />} />
          <Route path="*" element={<Gateway lang={lang} setLang={setLang} />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" position="bottom-right" richColors />
    </div>
  );
}

export default App;
